<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp32',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, getPageThemeColor,
    onCheckDetail(subModuleName) {
      this.$store.commit('config/SET_CURRENT_MODALNAME', subModuleName)
      this.$store.commit('config/SET_CURRENT_MODULE_ID', 32_1)
      this.$store.commit('config/SET_DIALOG', true)
      // if (subModuleName === '洪韵雅廉') {
      //   this.$store.commit('config/SET_CURRENT_MODALNAME', subModuleName)
      //   this.$store.commit('config/SET_DIALOG', true)
      // } else window.location.href = 'https://jdydt.ccdi.gov.cn'
    }
  }
}
</script>

<template>
  <div class="modules-id-32">
    <module-title :title="moduleOption.title" margin-bottom="23" />
    <div class="comp-vertical-3 modules-id-32-content">
      <div class="member-box">
        <div v-for="(v, i) in moduleOption.list.slice(0, 3)" :key="`modules-32-${i}`" class="item">
          <el-image class="avator" :src="v.photo | imgPath" alt="avator" fit="cover" />
          <p class="post">{{ v.post || '' }}</p>
          <p class="name">{{ v.name || '' }}</p>
          <!-- <p class="phone">电话: {{ v.phone | hiddenPhone }}</p> -->
        </div>
      </div>

      <div class="bottom-box">
        <div class="qrcode-box">
          <el-image class="qrcode" :src="require('imgs/modules/id-32-qrcode.png')" alt="qrcode" fit="cover" />
          <div class="right">
            <p class="title">“码上举报”二维码</p>
            <p class="content h-line-3">您可扫码反映党组织、党员、监察对象违反党的法律、违法违规等问题。</p>
          </div>
        </div>
        <div class="label-box">
          <p class="item" @click.stop="onCheckDetail('洪韵雅廉')">洪韵雅廉</p>
          <p class="item" @click.stop="onCheckDetail('小微权力“监督一点通”')">小微权力“监督一点通”</p><!-- https://jdydt.ccdi.gov.cn/#/ -->
        </div>
        <div class="intro-box">
          <p class="title h-line-1">[小微权力监督一点通]</p>
          <p class="content h-line-3">您可以从本平台反映村（社区）干部在公开事项、安民惠农政策资金补贴发放、办事作风、工程项目建设等方面不公正、不作为、慢作为、乱作为问题。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-32-content {
  display: flex;
  flex-direction: column;
}
.member-box {
  width: 450px;
  display: flex;
  justify-content: space-evenly;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
  }
  .avator {
    width: 77px;
    height: 99px;
  }
  .name, .post, .phone {
    width: 130px;
    font-size: 14px;
    font-weight: bold;
    color: #000;
    text-align: center;
  }
  .name {
    margin-top: 8px;
  }
  .post, .phone {
    margin-top: 4px;
  }
}

.bottom-box {
  width: 450px;
  height: 571px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  background: #fff;
  box-shadow: 0 3px 17px 0 rgba(0, 65, 150, 0.1);
  border-radius: 5px;
  padding: 8px 0 0;
  box-sizing: border-box;

  background: linear-gradient(180deg, #fff 90%, #ccf4f4 100%, #50B7B5);
  .qrcode-box {
    width: 436px;
    height: 136px;
    border-radius: 5px;
    box-shadow: 0 7px 5px 0 rgba(14, 126, 164, 0.1);
    background-color: #fff;
    border: 2px solid transparent;
    border-radius: 5px;
    background-image: linear-gradient(#fff, #fff), linear-gradient(0deg, #1594C6, #3A9F77);
    background-origin: border-box;
    background-clip: content-box, border-box;
    display: flex;
    align-items: center;
    .qrcode {
      width: 120px;
      height: 122px;
      margin-left: 5px;
    }
    .right {
      width: 270px;
      height: 122px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      margin-left: 17px;
      .title {
        width: 100%;
        font-size: 17px;
        font-weight: 800;
        color: #3C9F73;
      }
      .content {
        width: 100%;
        font-size: 15px;
        font-weight: 800;
        color: #000;
        line-height: 23px;
      }
    }
  }
  .label-box {
    width: 418px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 15px;
    margin-top: 68px;
    .item {
      min-width: 130px;
      height: 40px;
      background: linear-gradient(95deg, #50B7B5, #58C2F6);
      border: 2px solid #EBF7FF;
      box-shadow: 3px 7px 0 0 rgba(0, 0, 0, 0.26);
      border-radius: 10px;
      text-align: center;
      line-height: 30px;
      padding: 2px 10px 0;
      box-sizing: border-box;
      cursor: pointer;

      font-size: 19px;
      font-family: siyuansong;
      font-weight: 800;
      color: #fff;
    }
  }
  .intro-box {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    .title {
      width: 300px;
      font-size: 21px;
      font-family: siyuansong;
      font-weight: 800;
      color: #3C5F8D;
      text-align: center;
    }
    .content {
      width: 400px;
      font-size: 17px;
      font-weight: 800;
      color: #3C5F8D;
      line-height: 26px;
      margin-top: 30px;
    }
  }
}
</style>
